import React from 'react';
import { NegotiatorTableContainer, Td, Th, Thead } from './styles';
import { Table } from 'reactstrap';
import MuiMultSelect from 'newComponents/MuiMultSelect';
import { ACTIVE_CHATS_TITLE, DEALS_CLOSED_TITLE, STARTED_MESSAGES_TITLE, UNREAD_MESSAGES_TITLE, CALLS_MADE_TITLE, CALLS_WITH_ANSWER_TITLE } from './hooks/utils';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';

export const NegotiatorTable = ( { 
	data, 
	allNegotiators, 
	selectedNegotiators, 
	onFilterChange, 
	currentPage, 
	totalPages, 
	onPageChange, 
	itemsPerPage, 
	totalItems,
	sortConfig,
	onSortChange
} ) => {
	// Preparar opções para o MuiMultSelect
	const negotiatorOptions = allNegotiators?.map( negotiator => ( {
		id   : negotiator.userEmail,
		name : negotiator.userEmail
	} ) ) || [];

	// Componente para cabeçalho com ordenação
	const SortableHeader = ( { title, sortKey } ) => {
		const isActive = sortConfig.key === sortKey;
		
		return (
			<Th 
				onClick={() => onSortChange( sortKey )}
				style={{
					cursor          : 'pointer',
					backgroundColor : isActive ? '#f8f9fa' : 'transparent',
					color           : isActive ? '#343a40' : '#6c757d',
					fontWeight      : isActive ? '600' : '500',
					position        : 'relative',
					userSelect      : 'none'
				}}
				title={`Ordenar por ${title}`}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					{isActive && (
						sortConfig.direction === 'desc' ? 
							<ArrowDownward style={{ 
								fontSize : '16px',
								opacity  : 0.8,
								color    : '#343a40'
							}} /> :
							<ArrowUpward style={{ 
								fontSize : '16px',
								opacity  : 0.8,
								color    : '#343a40'
							}} />
					)}
					{title}
				</div>
			</Th>
		);
	};

	return (
		<NegotiatorTableContainer>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
				<span className='SectionTitle'>Negociadores</span>
				<div style={{ width: '300px', padding: '16px' }}>
					<MuiMultSelect
						options={negotiatorOptions}
						selected={selectedNegotiators}
						callback={onFilterChange}
						label="negociadores"
						width="100%"
						showLabel={false}
					/>
				</div>
			</div>
			<Table>
				<Thead>
					<tr>
						<Th>Nome</Th>
						<Th>Departamento</Th>
						<SortableHeader title={ACTIVE_CHATS_TITLE} sortKey="activeChats" />
						<SortableHeader title={DEALS_CLOSED_TITLE} sortKey="dealsClosed" />
						<SortableHeader title={STARTED_MESSAGES_TITLE} sortKey="startedMessages" />
						<SortableHeader title={UNREAD_MESSAGES_TITLE} sortKey="unreadCount" />
						<SortableHeader title={CALLS_MADE_TITLE} sortKey="callsMade" />
						<SortableHeader title={CALLS_WITH_ANSWER_TITLE} sortKey="callsWithResponse" />
					</tr>
				</Thead>
				<tbody>
					{data?.map( ( item, idx ) => (
						<tr key={idx}>
							<Td>{item.userEmail}</Td>
							<Td style={{ textTransform: 'capitalize' }}>{item.departmentName}</Td>
							<Td>{item.activeChats}</Td>
							<Td>{item.dealsClosed}</Td>
							<Td>{item.startedMessages}</Td>
							<Td>{item.unreadCount}</Td>
							<Td>{item.callsMade}</Td>
							<Td>{item.callsWithResponse}</Td>
						</tr>
					) )}
				</tbody>
			</Table>
			
			{/* Controles de Paginação */}
			<div style={{ 
				display        : 'flex', 
				justifyContent : 'space-between', 
				alignItems     : 'center', 
				marginTop      : '16px',
				padding        : '8px 16px'
			}}>
				<span style={{ fontSize: '14px', color: '#666' }}>
					Mostrando {Math.min( ( currentPage - 1 ) * itemsPerPage + 1, totalItems )} - {Math.min( currentPage * itemsPerPage, totalItems )} de {totalItems} negociadores
				</span>
				
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<button 
						onClick={() => onPageChange( currentPage - 1 )}
						disabled={currentPage === 1}
						style={{
							padding         : '6px 12px',
							border          : '1px solid #ddd',
							backgroundColor : currentPage === 1 ? '#f5f5f5' : '#fff',
							color           : currentPage === 1 ? '#999' : '#333',
							cursor          : currentPage === 1 ? 'not-allowed' : 'pointer',
							borderRadius    : '4px'
						}}
					>
						Anterior
					</button>
					
					<span style={{ fontSize: '14px', margin: '0 8px' }}>
						Página {currentPage} de {totalPages}
					</span>
					
					<button 
						onClick={() => onPageChange( currentPage + 1 )}
						disabled={currentPage === totalPages || totalPages === 0}
						style={{
							padding         : '6px 12px',
							border          : '1px solid #ddd',
							backgroundColor : ( currentPage === totalPages || totalPages === 0 ) ? '#f5f5f5' : '#fff',
							color           : ( currentPage === totalPages || totalPages === 0 ) ? '#999' : '#333',
							cursor          : ( currentPage === totalPages || totalPages === 0 ) ? 'not-allowed' : 'pointer',
							borderRadius    : '4px'
						}}
					>
						Próxima
					</button>
				</div>
			</div>
		</NegotiatorTableContainer>
	);
};